import { defineChain } from '../../utils/chain/defineChain.js'

export const foundry = /*#__PURE__*/ defineChain({
  id: 31_337,
  name: 'Foundry',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: {
      http: ['http://127.0.0.1:8545'],
      webSocket: ['ws://127.0.0.1:8545'],
    },
  },
})
